import React, { useEffect, useState } from "react";
import CreateInvoice from "../../../../../entities/DashboardPage/AccountingModule/Invoice/CreateInvoice";
import AuthService from "../../../../../api/AuthService";
import { useNavigate } from "react-router-dom";

import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";

const CreateInvoicePage = () => {
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [customerList, setCustomerList] = useState([]);

  useEffect(() => {
    getItem();
    getCustomerList();
  }, []);

  const getCustomerList = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getCustomer(text, sort, page);
      if (result?.success) {
        setCustomerList(result?.data?.customers)
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getItem = async (text) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getItemsList(text);
      if (result?.success) {
        setItemList(result?.data?.items);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };

  const handleAddNewInvoice = async (invoiceData) => {
    LoaderHelper.loaderStatus(true);
    
    try {
      const result = await AuthService.handleInvoice(invoiceData);      
      if (result?.success === true) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/invoice");
      } else {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "API error: Invoice not created", "error");
      }
    } catch (apiError) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
      showAlert(
        "API/network error: " +
        (apiError?.response?.data?.message ||
          apiError?.message ||
          JSON.stringify(apiError)),
        "error"
      );
      return;
    }
  };
  return (
    <CreateInvoice handleAddNewInvoice={handleAddNewInvoice} handleCustomer={getCustomerList} customerList={customerList} itemList={itemList} handleItem={getItem} loading={loading} handleItemList={getItem} />
  )
}


export default CreateInvoicePage;
